import { render, staticRenderFns } from "./FooterCopyright.vue?vue&type=template&id=c11a28a8&scoped=true&lang=pug&"
import script from "./FooterCopyright.vue?vue&type=script&lang=js&"
export * from "./FooterCopyright.vue?vue&type=script&lang=js&"
import style0 from "./FooterCopyright.vue?vue&type=style&index=0&id=c11a28a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11a28a8",
  null
  
)

export default component.exports